// import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const exportToExcel = async (jsonData, fileName = 'data.xlsx') => {
	const XLSX = await import('xlsx');
	// Convert JSON to worksheet
	const worksheet = XLSX.utils.json_to_sheet(jsonData);

	// Create a new workbook and append the worksheet
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

	// Write the workbook and create a Blob
	const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
	const data = new Blob([excelBuffer], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	});

	// Save the file
	saveAs(data, fileName);
};
